module.exports = __webpack_public_path__ + "media/images/gift_plan/doted-ba1da6428e2b79b07af6c55a50412304.png";